<ng-container *ngIf="contentlet$ | async as contentlet">
  <div class="default-faq-class">
    <h1 class="text-center faq-main-heading mt-5 mb-4">{{ contentlet.widgetTitle }}</h1>
    <div class="mb-2 position-relative">
      <ng-container *ngFor="let faq of contentlet.faq">
        <custom-dot-cms-faq [identifier]="faq.identifier"></custom-dot-cms-faq>
      </ng-container>
    </div>
  </div>
</ng-container>
